module.exports = __webpack_public_path__ + "img/bell-gray-dot.07905945.svg";